import { Component, effect, OnInit } from '@angular/core';
import { LayoutService } from '../layout.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { RouterModule } from '@angular/router';
import { Subject } from 'rxjs';
import { environment } from '../../../environments/default/environment';
import { PRPVUserFull, ApiPurpleFitRegisterRequest, ApiPurpleFitCompleteRegistrationRequest, ApiPurpleFitUpdateUserInfoRequest } from '../../../core-modules/sdk';
import { hamburgerAnimation, PurpleBreakpointsService, PurpleStringExtensions } from '@purple-lib/purple-utilities';
import { PurpleEditableImageDirective } from '@purple-lib/purple-edit-medias';
import { PurpleTranslationService } from '@purple-lib/purple-translations-core';
import { PurpleUserService } from '@purple-lib/purple-users-core';

@Component({
    selector: 'purple-fit-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    animations: [hamburgerAnimation],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NzDrawerModule,
        NzMenuModule,
        NzIconModule,
        NzSelectModule,
        RouterModule,
        PurpleEditableImageDirective
    ]
})
export class HeaderComponent implements OnInit {
  menuOpen: boolean = false;
  mobileMenuClass = 'close';
  sub: Subject<void> = new Subject();

  showTabMenu: boolean = environment.SHOW_TAB_MENU_MOBILE;
  
  constructor(public breakSvc: PurpleBreakpointsService, public tsvc: PurpleTranslationService, public layoutSvc: LayoutService,
    private userSvc: PurpleUserService<PRPVUserFull, ApiPurpleFitRegisterRequest, ApiPurpleFitCompleteRegistrationRequest, ApiPurpleFitUpdateUserInfoRequest>
  ) {
    effect(() => {
      const deviceSize = this.breakSvc.breakPointDevice();
      if(deviceSize != undefined){
        this.layoutSvc.setCurrentActiveMenu(this.userSvc.isLoggedIn);
      }
    });
  }

  ngOnInit(){
  }

  ngOnDestroy() {
    this.sub.next();
    this.sub.complete();
  }

  hamburgerClick() {
    if (this.menuOpen) {
      this.mobileMenuClass = 'close'
      setTimeout(() => {
        this.menuOpen = !this.menuOpen;
      }, 300);
    } else {
      this.menuOpen = !this.menuOpen;
      setTimeout(() => {
        this.mobileMenuClass = 'open'
      }, 300);
    }
  }

  async mobileNavigate() {
    this.menuOpen = false;
  }

  isSelectedLanguage(lanId: string): boolean{
    return PurpleStringExtensions.strEq(this.tsvc.currentLanguage(), lanId);
  }

  
  getLanguageName(lanName: string): string{
    return lanName.substring(0, 3);
  }

  async switchLanguage(lanId: string){
    await this.tsvc.switchLanguage(lanId);
  }
}
